import {ObjectTransformation} from './ObjectTransformation';
import {WallObjectTransformation} from './WallObjectTransformation';
import {ObjectCheckerService} from '../../../object-checker.service';
import {WallCutService} from '../../../wall/wall-cut.service';
import {Injectable} from '@angular/core';

@Injectable()
export class ObjectTransformationFactory {

  constructor(
    private objectCheckerSrvc: ObjectCheckerService,
    private wallCutSrvc: WallCutService
  ) {
  }

  build(object): ObjectTransformation {
    let result;
    if (this.objectCheckerSrvc.isWallEmbeddable(object)) {
      result = new WallObjectTransformation(object, this.wallCutSrvc);
    } else {
      result = new ObjectTransformation(object);
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/common/ObjectTransformation/ObjectTransformationFactory.ts